var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"Order Inputs","icon":"mdi-flower-outline"}}),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.inputOrders}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }